var _path, _path2, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.991,10.553l-1.96,1.39-1.981-1.392c-2.565-1.803-4.092-4.742-4.092-7.877h0s12.091,0,12.091,0v.026c0,3.121-1.513,6.048-4.059,7.854Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.017,13.39l1.96-1.39,1.981,1.392c2.565,1.803,4.092,4.742,4.092,7.877h0s-12.091,0-12.091,0v-.026c0-3.121,1.513-6.048,4.059-7.854Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.102,
    y1: 2.673,
    x2: 19.906,
    y2: 2.673
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.102,
    y1: 21.327,
    x2: 19.906,
    y2: 21.327
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.b391c056916dc105f2cac7d7fab12c19.svg";
export { ForwardRef as ReactComponent };